import { COLOR_BRAND_ORANGE_500, COLOR_BRAND_ORANGE_700, COLOR_GRAY_800, } from '../../../themes/InaccessibleLight/colors.values';
export function getTextDecorationColor(transformer) {
    return Object.freeze({
        gray800: transformer.textDecorationColor(COLOR_GRAY_800),
        brand: {
            orange500: transformer.textDecorationColor(COLOR_BRAND_ORANGE_500),
            orange700: transformer.textDecorationColor(COLOR_BRAND_ORANGE_700),
        },
    });
}
